import { render, staticRenderFns } from "./CopyToWorkspace.vue?vue&type=template&id=37df0285&scoped=true&"
import script from "./CopyToWorkspace.vue?vue&type=script&lang=js&"
export * from "./CopyToWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./CopyToWorkspace.vue?vue&type=style&index=0&id=37df0285&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df0285",
  null
  
)

export default component.exports